import { AppDatabase } from 'db/db';

export * from 'db/actions';
export * from 'db/models';
export * from 'controllers/hooks';

export const _db = new AppDatabase();
export const deleteDatabase = () => _db.delete();
